// extracted by mini-css-extract-plugin
module.exports = {"container":"airfields_container__2fP8x"};